/**
 * Survey launcher factory for Web SDK
 */

import { Api } from "@ms-ofb/officefloodgatecore";
import CoachingUXLauncherFactory from "./CoachingUXLauncherFactory";
import RudeSurveyLauncherFactory from "./RudeSurveyLauncherFactory";
import { isNullOrUndefined } from "util";

export default class AdaptiveSurveyLauncherFactory implements Api.ISurveyLauncherFactory {
	public static make(): Api.ISurveyLauncherFactory {
		return new AdaptiveSurveyLauncherFactory(
			new RudeSurveyLauncherFactory(),
			new CoachingUXLauncherFactory());
	}

	private rudeSurveyLauncherFactory: RudeSurveyLauncherFactory;
	private coachingUXLauncherFactory: CoachingUXLauncherFactory;

	private constructor(rudeSurveyLauncherFactory: RudeSurveyLauncherFactory,
		coachingUXLauncherFactory: CoachingUXLauncherFactory) {
		this.rudeSurveyLauncherFactory = rudeSurveyLauncherFactory;
		this.coachingUXLauncherFactory = coachingUXLauncherFactory;
	}

	public makeSurveyLauncher(survey: Api.ISurvey): Api.ISurveyLauncher {
		if (isNullOrUndefined(survey)) {
			return null;
		}

		switch (survey.getLauncherType().toLocaleLowerCase()) {
			case CoachingUXLauncherFactory.LAUNCHER_TYPE:
				return this.makeGenericMessagingSurfaceLauncher(survey);
			case RudeSurveyLauncherFactory.LAUNCHER_TYPE:
			default:
				return this.makeRudeSurveyLauncher(survey);
		}
	}

	public AcceptsSurvey(survey: Api.ISurvey): boolean {
		if (isNullOrUndefined(survey)) {
			return false;
		}

		switch (survey.getLauncherType().toLocaleLowerCase()) {
			case CoachingUXLauncherFactory.LAUNCHER_TYPE:
				return (!isNullOrUndefined(this.coachingUXLauncherFactory)
						&& this.coachingUXLauncherFactory.AcceptsSurvey(survey));
			case RudeSurveyLauncherFactory.LAUNCHER_TYPE:
			// Since by deafult rude survey launcher has to be returned for any other launcher type
			// then we should check whether it's launcher factory is available and it accepts surveys for any launcher.
			default:
				return (!isNullOrUndefined(this.rudeSurveyLauncherFactory)
						&& this.rudeSurveyLauncherFactory.AcceptsSurvey(survey));
		}
	}

	private makeGenericMessagingSurfaceLauncher(survey: Api.ISurvey): Api.ISurveyLauncher {
		if (!isNullOrUndefined(this.coachingUXLauncherFactory)) {
			return this.coachingUXLauncherFactory.makeSurveyLauncher(survey);
		}

		return null;
	}

	private makeRudeSurveyLauncher(survey: Api.ISurvey): Api.ISurveyLauncher {
		if (!isNullOrUndefined(this.rudeSurveyLauncherFactory)) {
			return this.rudeSurveyLauncherFactory.makeSurveyLauncher(survey);
		}

		return null;
	}
}
